import React, { useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import useWindowWidth from '../../hooks/useWindowWidth';

export default function AppLayout({ children }) {
  const width = useWindowWidth();
  const isMobile = width < 768;
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  const mainStyle = {
    fontFamily: "'Segoe UI', sans-serif",
    marginLeft: !isMobile && sidebarOpen ? '220px' : 0,
    marginTop: '60px',
    minHeight: 'calc(100vh - 60px)',
    backgroundColor: '#f0f4f8',
    padding: isMobile ? '16px' : '32px',
    transition: 'margin-left 0.3s ease',
  };

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif" }}>
      <Navbar
        onMenuToggle={() => setSidebarOpen(o => !o)}
        isMobile={isMobile}
        sidebarOpen={sidebarOpen}
      />
      <Sidebar
        open={sidebarOpen}
        isMobile={isMobile}
        onClose={() => setSidebarOpen(false)}
      />
      {/* Overlay for mobile only */}
      {isMobile && sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 98,
          }}
        />
      )}
      <main style={mainStyle}>
        {children}
      </main>
    </div>
  );
}
